import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { fadeInUp } from "./animations";

const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height:100vh;
  max-width: 420px;
  min-width:350px;
  overflow-x: hidden;
  min-height: 100vh;
  background-color: ${(props) =>
  props.color ? props.background : "transparent"};
  background-image: ${(props) =>
  props.backgroundimage ? `url(${props.backgroundimage})` : "none"};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  padding: 0 16px;
  /* overflow-y: auto; */
  padding-top: calc(12vh + var(--tg-safe-area-inset-top, 0px));
  padding-bottom: calc(77px + var(--tg-safe-area-inset-bottom, 0px));
  z-index: 1;
  min-height: 665px;
  /* @media (min-width: 420px) {
    padding:16vh 44px 10vh;
  } */
`;

export const AnimatedList = styled.div`
opacity: 0;
animation: ${fadeInUp} 0.5s ease forwards;
`


const FlexContainer = styled.div`
    display: flex;
    justify-content: ${(props) => props.justifyContent || "center"};
    align-items: ${(props) => props.alignitems || "center"};
    flex-direction: ${(props) => props.flexdirection || "row"};
    gap: ${(props) => props.gap || "16px"};
    width: 100%;
`
const StyledHeader = styled.div`
  position: fixed;
  top: 0;
  /* left: 0; */
  width: 100%;
  max-width: 420px;
  height: calc(12vh + var(--tg-safe-area-inset-top, 0px));
  min-height: 60px;
  padding-top: var(--tg-safe-area-inset-top);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  clip-path: polygon(0% 0%, 100% 0, 100% 80%, 50% 100%, 0 80%);
  z-index: 2;
  background-color: ${(props) =>
    props.backgrroundColor ? props.backgrroundColor : "#342E72"};
`;
const HeaderOverlay = styled.div`
  clip-path: ellipse(57% 40% at 50% 6%);
  width: 100%;
  height: 100%;
  background-color: #d2bfff;
  position: absolute;
  top: -16px;
  opacity: 0.3;
`;
const HeaderBorder = styled.div`
  clip-path: polygon(50% 100%, 100% 80%, 100% 78%, 50% 98%, 0 78%, 0 80%);
  background-color: #d2bfff;
  position: absolute;
  width: 100%;
  height: 100%;
  top: -6px;
`;

const StyledFooter = styled.div`
  position: fixed;
  bottom: 0;
  max-width: 420px;
  height: 77px;
  width: 100%;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.backgrroundColor
      ? props.backgrroundColor
      : props.theme.colors.secondary};
  z-index: ${(props) => props.zIndex};
`;
const StyledBottomNavContainer = styled.div`
  width: 100%;
  height: 67px;
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.colors.secondary};
  overflow: hidden;
`;
const StyledNavItemsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.dark};
`;
const StyledNavItem = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.text.light};
  text-decoration: none;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 900;
  border: 1px solid ${(props) => props.theme.colors.dark};
  span {
    margin-top: 4px;
  }
  &[aria-current="page"] {
    background-color: ${(props) => props.theme.colors.activeLink};
    color: ${(props) => props.theme.colors.light};
    justify-content: flex-end;
    svg {
      transform: scale(1.7);
      top: 8px;
      position: absolute;
    }
    span {
      margin-bottom: 6px;
    }
  }
`;
const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  background-color: ${(props) =>
    props.bordered ? "transparent" : props.theme.colors.primary};
  color: ${(props) =>
    props.bordered ? props.theme.colors.primary : props.theme.colors.light};
  font-size: 18px;
  border: ${(props) =>
    props.bordered ? `2px solid ${props.theme.colors.primary}` : "none"};
  border-radius: 8px;
  padding: 0 16px;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.colors.danger};
  }
`;
const IconButton = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4vh;
  max-height: 40px;
  padding: 6px;
  border-radius: 100px;
  width: 100%;
  max-width: calc(20 * var(--vw));
  color: ${(props) => props.theme.colors.light};
  background: ${(props) => props.theme.colors.gradient1};
  border: 1.5px solid ${(props) => props.theme.colors.light};
  outline: none;
`;
const IconBackground = styled.div`
  position: absolute;
  background: ${(props) =>
    props.$backgroundColor || props.theme.yellow.gradient};
  width: 100%;
  height: ${(props) => props.$height || "84%"};
  top: 0;
  border-radius: 100px;
`;
const StyledBuyButton = styled.button`
  background: linear-gradient(to bottom,#445cf4 49%, #2c3cd0 55%);
  display: flex;
  align-items: center;
  height: 7vh;
  padding: 12px 24px;
  outline: none;
  border-radius: 100px;
  color: #fff;
  border-width: 0 0 6px 0;
  border-color: #7082ff;
  position: relative;
  overflow: hidden;
`;
const SecondaryButton = styled.button`
   border: 1px solid #FFFFFF;
   background: ${(props) => props.bordered ? "transparent" :props.theme.colors.gradient1};
   border-radius: 100px;
   outline: none;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    padding: 8px;
    backdrop-filter: blur(10px);
    box-shadow: ${(props) => props.bordered ? "none" : "0px 4px 0px 0px #6747AC"};
    font-size: 14px;
    color: #FFFFFF;
    font-weight: 600;
    min-width: 80px;
`
const GradientText = styled.span`
  background: ${(props) =>props.color ? props.color : props.theme.colors.text.gradient};
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 4px 4px 6px rgba(0,0,0,0.21);

`;
const TitleWithHorizontalLine = styled.div`
  display: flex;
  width:100%;
  align-items: center;
  justify-content: center;
  text-shadow: -1px 0 10px  #7556BF;
  gap: 10px;
  font-size: 24px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.text.light};
  white-space: nowrap;

  &:before, &:after {
    content: "";
    flex: 1;
    height: 1px;
    background-color: #7556bf;
  }
`;
const PrimaryButton = styled.button`
  background: linear-gradient(180deg, #3977AD 12.44%, #29497C 45.28%, #00195C 50.97%, #00558B 100%);
  border: 1px solid #FFFFFF;
  backdrop-filter: blur(10.800000190734863px);
  box-shadow: 0px 7px 0px 0px #003383;
  border-radius: 30px;
  outline: none;
  font-size: 16px;
  font-weight: 600;
  height: 55px;
  width: 100%;
  color:${(props) => props.theme.colors.light};
  cursor: pointer;
`

const ScrollableContainer = styled.div`
    overflow-y: auto;
    width: 100%;
    height: 100%;
`
const NonFlexContainer = styled.div`
  width:100%;
  height:100%;
`
export {
  Page,
  StyledHeader,
  StyledFooter,
  StyledBottomNavContainer,
  StyledNavItemsContainer,
  StyledNavItem,
  StyledButton,
  IconButton,
  StyledBuyButton,
  HeaderOverlay,
  HeaderBorder,
  GradientText,
  TitleWithHorizontalLine,
  FlexContainer,
  SecondaryButton,
  PrimaryButton,
  ScrollableContainer,
  NonFlexContainer,
  IconBackground
};
